<template>
  <v-layout xs12 align-start row wrap>
    <v-flex xs12 sm12 md12 justify-center>
      <h2 class="ml-2 mb-2">Importar Preço</h2>
      <v-container fluid>
        <v-card>
          <v-col md12 class="topSearch">
            <v-row fluid>
              <v-flex md6>
                <vue-csv-import
                  v-model="parseCsv"
                  :map-fields="{
                    ean1: 'EAN 1',
                    ean2: 'EAN 2',
                    ean3: 'EAN 3',
                    estoque: 'Estoque',
                    precoTabela: 'Preço Tabela',
                    precoPromocional: 'Preço Promocional',
                    validade: 'Data de Validade da Promoção'
                  }"
                >
                  <template slot="hasHeaders" slot-scope="{ headers, toggle }">
                    <label>
                      <input
                        type="checkbox"
                        id="hasHeaders"
                        :value="headers"
                        @change="toggle"
                      />
                      Cabeçalho ?
                    </label>
                  </template>
                  <template slot="error">
                    File type is invalid
                  </template>
                  <template slot="thead">
                    <tr>
                      <th>My Fields</th>
                      <th>Column</th>
                    </tr>
                  </template>
                  <template slot="next" slot-scope="{ load }">
                    <p>
                      <br />
                      <v-btn color="primary" @click.prevent="load"
                        >Carregar CSV</v-btn
                      >
                    </p>
                  </template>
                  <template slot="submit" slot-scope="{ submit }">
                    <button @click.prevent="submit">send!</button>
                  </template>
                </vue-csv-import>
              </v-flex>
              <v-flex md5>
                <h3>Escolher a drogaria</h3>
                <br />
                <ApolloQuery
                  :query="
                    gql => gql`
                      query ListDrugstores {
                        drugstores(where: { enabled: { _eq: true } }) {
                          id
                          name
                        }
                      }
                    `
                  "
                >
                  <template v-slot="{ result: { data } }">
                    <v-autocomplete
                      v-if="data"
                      v-model="iddrugstore"
                      v-bind:items="toArray(data.drugstores)"
                      filled
                      label="Drogaria*"
                      item-text="name"
                      item-value="id"
                    >
                    </v-autocomplete>
                  </template>
                </ApolloQuery>
                <v-btn
                  class="teal"
                  @click.prevent="importPrice"
                  :loading="loading"
                  :disabled="loading"
                  >Importar</v-btn
                >
              </v-flex>
            </v-row>
          </v-col>
        </v-card>
      </v-container>
      <v-container fluid>
        <v-data-table :headers="headers" :items="parseCsv"></v-data-table>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueCsvImport } from "vue-csv-import";
import {
  InsertMultipleImportPrice,
  UpSertPrice
} from "../../graphql/ImportPrice.graphql";
import * as moment from "moment";
import numeral from "numeral";
import "numeral/locales";
import collect from "collect.js";
numeral.locale("pt-br");

export default {
  name: "Price",
  components: { VueCsvImport },
  // eslint-disable-next-line no-unused-vars
  data: vm => ({
    parseCsv: [],
    loading: false,
    iddrugstore: 0,
    headers: [
      { text: "Ean 1", align: "start", sortable: false, value: "ean1" },
      { text: "Ean 2", align: "start", sortable: false, value: "ean2" },
      { text: "Ean 3", align: "start", sortable: false, value: "ean3" },
      { text: "Estoque", value: "estoque" },
      { text: "Preço Tabela", value: "precoTabela" },
      { text: "Preço Promocional", value: "precoPromocional" },
      { text: "Data de Validade da Promoção", value: "validade" }
    ]
  }),
  methods: {
    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    },
    async importPrice() {
      let drugstore = this.iddrugstore;
      this.loading = true;
      const objects = this.parseCsv.map(value => {
        let data = moment(value.validade, "DD-MM-YYYY");
        if (data.isValid()) {
          data = data.format("YYYY-MM-DD");
        } else {
          data = null;
        }
        return {
          ean1: value.ean1 ? value.ean1 : 0,
          ean2: value.ean2 ? value.ean2 : 0,
          ean3: value.ean3 ? value.ean3 : 0,
          storage: value.estoque ? parseInt(value.estoque.trim()) : 0,
          retail: value.precoTabela.replace(",", ".").trim(),
          discount: value.precoPromocional
            ? value.precoPromocional.replace(",", ".").trim()
            : "0",
          expiration: data,
          id_drugstore: parseInt(drugstore)
        };
      });

      let splitObjects = collect(objects);
      let chunks = splitObjects.chunk(500);
      let total = chunks.count();

      await chunks.each(async objects => {
        this.$apollo
          .mutate({
            mutation: InsertMultipleImportPrice,
            variables: { objects: objects }
          })
          .then(async data => {
            let prices = data.data.insert_import_price.returning;
            //console.log(prices);
            //const notUndefined = anyValue => typeof anyValue !== "undefined";
            const objPrices = prices
              .map(price => {
                if (price.id_product != null) {
                  return {
                    cost: 0,
                    enabled: true,
                    storage: price.storage,
                    retail: price.retail,
                    discount: price.discount,
                    expiration: price.expiration,
                    id_drugstore: price.id_drugstore,
                    id_product: price.id_product,
                    issale: moment(price.expiration).isValid()
                  };
                }
              })
              .filter(Boolean);
            console.log(objPrices);

            await this.$apollo.mutate({
              mutation: UpSertPrice,
              variables: { objects: objPrices }
            });
            total = total - 1;
            this.loading = total == 0 ? false : true;
          });
      });
    }
  }
};
</script>

<style lang="stylus">
.topSearch
    margin: 10px
</style>
